export const ApprovalEditabilityStates = {
  Editable: 0,
  WaitingForNomination: 1,
  ReadOnly: 2
};

export const DecisionStatus = {
  Approved: "APPROVED",
  Rejected: "REJECTED",
  Conditional: "CONDITIONAL"
};

export const DecisionBehavior = {
  WithoutReason: "WITHOUTREASON",
  WithReason: "WITHREASON",
  OnlyOneReason: "ONLYONEREASON"
};
